import { useTranslation } from 'react-i18next';
import { OrganizationModuleType } from 'src/domain/organization';
import { ModuleSettingsScreen } from '../components/ModuleSettingsScreen';
import { AnalyticsIcon } from '.';

export const AnalyticsSettings = () => {
    const { t } = useTranslation();

    return (
        <ModuleSettingsScreen
            basePath="/app/analytics"
            icon={AnalyticsIcon}
            moduleType={OrganizationModuleType.analytics}
            moduleName={t('modules.analytics.navLabel')}
            memberDescription={t(
                'modules.analytics.members.settingsDescription',
            )}
            allowEmployeeReadAccess={false}
        />
    );
};
